module.exports = __webpack_public_path__ + "static/media/UniNeueBold-Italic.80b6daa5.ttf";